module.exports = __webpack_public_path__ + "static/media/MINI-TEST-COUNT-3.783fb7cb.png";